import {localize} from '@/utils/i18n'

const text = {
    inputPlaceholder: localize({
        ru: 'Введите свой email',
        en: 'Enter your email',
        cn: 'Enter your email'
    }),
    unsubscribe: localize({
        ru: 'Отписаться от&nbsp;рассылки',
        en: 'Cancel subscription',
        cn: 'Cancel subscription'
    }),
    allRubrics: localize({
        ru: 'Все рубрики',
        en: 'All rubrics',
        cn: 'All rubrics'
    }),

    unsubscribeTitle: localize({
        ru: 'Сожалеем, что вы&nbsp;отписались от&nbsp;нашей рассылки',
        en: 'We&nbsp;are sorry that you have unsubscribed from our mailing list.',
        cn: 'We&nbsp;are sorry that you have unsubscribed from our mailing list.'
    }),
    unsubscribeDescription: localize({
        ru: 'Нам очень жаль расставаться с&nbsp;вами. Надеемся, что вы&nbsp;скоро соскучитесь и&nbsp;вернетесь.',
        en: 'We&nbsp;are very sorry to&nbsp;part with you. We&nbsp;hope you get bored and come back soon.',
        cn: 'We&nbsp;are very sorry to&nbsp;part with you. We&nbsp;hope you get bored and come back soon.'
    }),

    editSuccessTitle: localize({
        ru: 'Вы&nbsp;успешно изменили подписку',
        en: 'You have successfully changed your subscription',
        cn: 'You have successfully changed your subscription'
    }),

    confirmTitle: localize({
        ru: 'Вы&nbsp;успешно подписались на&nbsp;рассылку новостей',
        en: 'You have successfully subscribed to&nbsp;the newsletter',
        cn: 'You have successfully subscribed to&nbsp;the newsletter'
    }),
    manageSubscriptionLink: localize({
        ru: 'Управление подпиской',
        en: 'Manage Subscription page',
        cn: 'Manage Subscription page'
    }),
    confirmDescription: localize({
        ru: 'Вы можете менять настройки подписки на странице ',
        en: 'You can change the subscription settings on&nbsp;the ',
        cn: 'You can change the subscription settings on&nbsp;the '
    }),
    subscribe: localize({
        ru: 'Подписаться',
        en: 'Subscribe',
        cn: 'Subscribe'
    }),
    change: localize({
        ru: 'Изменить',
        en: 'Change',
        cn: 'Change'
    }),
    editTitle: localize({
        ru: 'Управление подпиской',
        en: 'Subscription Management',
        cn: 'Subscription Management'
    }),
    subscribeTitle: localize({
        ru: 'Свежие публикации и&nbsp;уведомления с&nbsp;доставкой на&nbsp;электронную почту',
        en: 'Latest publications and notifications delivered to your&nbsp;email',
        cn: 'Latest publications and notifications delivered to your&nbsp;email'
    }),
    defaultError: localize({
        ru: 'Что-то пошло не так, попробуйте позже',
        en: 'Something went wrong, please try again later',
        cn: 'Something went wrong, please try again later'
    }),
    langMap: {
        ru: localize({
            ru: 'На русском языке',
            en: 'In Russian',
            cn: 'In Russian'
        }),
        en: localize({
            ru: 'На английском языке',
            en: 'In English',
            cn: 'In English'
        }),
        cn: localize({
            ru: 'На китайском языке',
            en: 'in Chinese',
            cn: 'in Chinese'
        })
    },
    allMap: {
        ru: 'Все рубрики',
        en: 'All rubrics',
        cn: 'All rubrics'
    },
    allPrograms: {
        ru: 'Все программы',
        en: 'All programs',
        cn: 'All programs'
    },
    reconfirmLink: localize({
        ru: 'отправить подтверждение повторно',
        en: 'resend confirmation',
        cn: 'resend confirmation'
    }),
    news: localize({
        ru: 'Новости',
        en: 'News',
        cn: 'News'
    }),
    programs: localize({
        ru: 'Уведомление о старте программы',
        en: 'Notification about start of program',
        cn: 'Notification about start of program'
    }),

    checkboxError: localize({
        ru: 'Пожалуйста, выберите хотя бы одну рубрику новостей или программу',
        en: '',
        cn: ''
    })
}

export { text }
